import { PlusOutlined } from '@ant-design/icons'
import { Flex, Modal } from 'antd'
import React from 'react'
import './aopsCommonConfirmModal.scss'
const AopsCommonConfirmModal = ({
  open = false,
  onClose,
  title,
  description,
  onConfirm,
  onCancel,
  iconType = 'plus',
}) => {
  const windowWidth = window.innerWidth * 0.4
  // const modalWidth = Math.max(windowWidth, 500)
  const iconMap = {
    plus: <PlusOutlined />,
  }
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="auto"
      centered
      style={{ padding: 0 }}
      className="aops-common-confirm-modal"
      closeIcon={null}
    >
      <div className="aops-common-confirm-modal">
        <p className="title">{title}</p>
        <p className="description">{description}</p>
        <Flex gap={8}>
          <button className=" btn btn-cancel" onClick={onCancel}>
            아니요, 바로 업무 완료
          </button>
          <button className=" btn btn-submit" onClick={onConfirm}>
            네, 패스트 업무 생성
            {iconType && <div className="icon">{iconMap[iconType]}</div>}
          </button>
        </Flex>
      </div>
    </Modal>
  )
}

export default AopsCommonConfirmModal
